import { TextLineStream, toTransformStream } from "@std/streams";
import { type Json } from "./json.ts";

/** Create a readable stream of strings from a readable stream of bytes */
export const streamLines = (
  stream: ReadableStream<Uint8Array>,
): ReadableStream<string> =>
  stream
    .pipeThrough(
      new TextDecoderStream() as ReadableWritablePair<string, Uint8Array>,
    )
    .pipeThrough(new TextLineStream());

/** Parse an async iterable of strings into a generator of JSON chunks */
export async function* generateJsonLinesAsync(lines: AsyncIterable<string>) {
  for await (const line of lines) {
    if (line.trim().length > 0) {
      yield JSON.parse(line);
    }
  }
}

/** Create a readable stream of JSON chunks from a readable stream of bytes */
export const streamJsonLines = (
  stream: ReadableStream<Uint8Array>,
): ReadableStream<Json> =>
  streamLines(stream).pipeThrough(toTransformStream(generateJsonLinesAsync));
